import { Daily10ResultsScreen } from '@/screens/daily10/Daily10ResultsScreen'

export default function () {
  return <Daily10ResultsScreen />
}
